import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';

var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "min-w-0 w-full" },
    [
      _c("div", { staticClass: "display-1" }, [_vm._v("Tabla")]),
      _vm._t("default"),
      _c(
        VCard,
        { staticClass: "audiencias" },
        [
          _c(
            VCardText,
            [
              _vm.is_load
                ? _c("form-metadata-table-component", {
                    ref: "form",
                    attrs: {
                      tplToWork: _vm.objToRequest,
                      isChangeRequest: _vm.TYPE_CHANGE_METADA.VIEWER_ONLY,
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
          _c(
            VCardActions,
            { staticClass: "pt-0 pl-3 pr-3 pb-3" },
            [
              _c(VSpacer),
              _c(
                VBtn,
                {
                  attrs: { color: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.$refs[_vm.MODAL_NAME].onOpen()
                    },
                  },
                },
                [
                  _c(VIcon, { attrs: { small: "" } }, [
                    _vm._v("icon-send "),
                  ]),
                  _vm._v(_vm._s(_vm.$t("btns.request"))),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "dialogs-component",
        {
          ref: _vm.MODAL_NAME,
          attrs: { title: "Request Access", width: 1200 },
        },
        [
          _c(
            "template",
            { slot: "body" },
            [
              _c("form-access-request-table-component", {
                key: _vm.key_request,
                ref: _vm.MODAL_NAME + "_body",
                attrs: { tplToWork: _vm.objToRequest },
                on: {
                  submit: function ($event) {
                    return _vm.$refs[_vm.MODAL_NAME].onClose()
                  },
                  cancel: function ($event) {
                    return _vm.$refs[_vm.MODAL_NAME].onClose()
                  },
                },
              }),
            ],
            1
          ),
          _c(
            "template",
            { slot: "btnsRight" },
            [
              _c(
                VBtn,
                {
                  attrs: { color: "primary" },
                  on: {
                    click: function ($event) {
                      _vm.$refs[_vm.MODAL_NAME + "_body"].onSubmit($event)
                    },
                  },
                },
                [
                  _c(VIcon, { attrs: { small: "" } }, [
                    _vm._v("icon-send "),
                  ]),
                  _vm._v(_vm._s(_vm.$t("btns.request"))),
                ],
                1
              ),
            ],
            1
          ),
        ],
        2
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }